import ('./style.scss')

import PieChart from './pie-chart'

export default PieChart